import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { LinkResult, PropertyMatch, PropertyShare } from '../../models/property-share.model';

/** Shared-property links (spec §8). X-User-Id / X-User-Name come from the api-key interceptor. */
@Injectable({ providedIn: 'root' })
export class PropertyShareService {
  private baseUrl = `${environment.apiUrl}/api/admin/property-shares`;

  constructor(private http: HttpClient) { }

  propertyMatches(propertyId: number): Observable<PropertyMatch[]> {
    return this.http.get<PropertyMatch[]>(`${this.baseUrl}/properties/${propertyId}/matches`);
  }

  enrollmentMatches(enrollmentId: number): Observable<PropertyMatch[]> {
    return this.http.get<PropertyMatch[]>(`${this.baseUrl}/enrollments/${enrollmentId}/matches`);
  }

  forAccount(accountId: number): Observable<PropertyShare[]> {
    return this.http.get<PropertyShare[]>(`${this.baseUrl}/accounts/${accountId}`);
  }

  link(guestPropertyId: number, homePropertyId: number): Observable<LinkResult> {
    return this.http.post<LinkResult>(this.baseUrl, { guestPropertyId, homePropertyId });
  }

  unlink(shareId: number): Observable<PropertyShare> {
    return this.http.post<PropertyShare>(`${this.baseUrl}/${shareId}/unlink`, {});
  }

  dismiss(propertyAId: number, propertyBId: number): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/dismissals`, { propertyAId, propertyBId });
  }
}
